export default __webpack_public_path__ + "static/media/The Grand Orchestra.6fb75157.png";